var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "diagram-viewer",
      style: { cursor: _vm.mousePressed ? "grabbing" : "grab" },
      on: {
        wheel: _vm.handleWheel,
        mousemove: _vm.handleMove,
        mousedown: function ($event) {
          _vm.mousePressed = true
        },
        mouseup: function ($event) {
          _vm.mousePressed = false
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "wrapper", style: { transform: _vm.transform } },
        [
          _c("BlockConnectors", {
            attrs: {
              blocks: _vm.blocks.blocks,
              metas: _vm.blocks.metas,
              "test-state": _vm.testState,
              "test-start-block-id": _vm.testStartBlockId,
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.blocks.blocks, function (block) {
            return _c("Block", {
              key: block.id,
              attrs: {
                block: block,
                metas: _vm.blocks.metas,
                active: _vm.selectedBlock === block.id,
                automation: _vm.automation,
                flattedDiagram: _vm.flattedDiagram,
                movingMode: _vm.movingMode,
                movingBlock: _vm.movingBlock,
                changeMoveMode: _vm.changeMoveMode,
                moveBlock: _vm.moveBlock,
                copyingMode: _vm.copyingMode,
                copyingBlock: _vm.copyingBlock,
                changeCopyMode: _vm.changeCopyMode,
                copyBlock: _vm.copyBlock,
                showNotification: _vm.showNotification,
                dragMode: _vm.dragMode,
                addBlockToDiagram: _vm.addBlockToDiagram,
                draggingType: _vm.draggingType,
                collapsed: false,
                collapsedAll: false,
                "start-test-from-here": _vm.startTestFromHere,
                "test-position": _vm.$_.get(_vm.testState, "position"),
                "test-closed": _vm.$_.get(_vm.testState, "closed", false),
                selected: _vm.selectedBlockId === block.id,
                "preview-mode": _vm.previewMode,
                getAllowedBlocks: _vm.getAllowedBlocks,
              },
              on: {
                openContextMenu: function (e) {
                  return _vm.$emit("openContextMenu", e)
                },
                focusBlock: _vm.focusBlock,
                updateAutomation: function ($event) {
                  return _vm.$emit("updateAutomation", $event)
                },
              },
            })
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }